import { createActions } from 'redux-actions'

import { map } from '../../utils/object'
import { SearchTypes } from '../constants'

import * as actions from './actions'

export const {
  search: {
    changeValue: changeSearchValue,
    setQuery: setSearchQuery,
    setType: setSearchType,
    resetFilters: resetSearchFilters,
    setFilters: setSearchFilters,
    setState: setSearchState,
    selectPrevResultItem,
    selectNextResultItem,
    job,
    company,
    toggleFilters,
    navigateUp,
    showFirstResult,
    hideFilters,
    showMobileSearchForm
  }
} = createActions({
  SEARCH: {
    CHANGE_VALUE: [query => ({ query }), (payload, meta) => meta],
    SET_QUERY: [query => ({ query }), (payload, meta) => meta],
    SET_TYPE: type => ({ type }),
    RESET_FILTERS: () => ({}),
    SET_FILTERS: (filters) => ({ filters }),
    SET_STATE: [payload => ({ ...payload }), (payload, meta) => meta],
    SELECT_PREV_RESULT_ITEM: () => ({ offset: -1 }),
    SELECT_NEXT_RESULT_ITEM: () => ({ offset: 1 }),
    TOGGLE_FILTERS: () => ({}),
    NAVIGATE_UP: [payload => payload, (_, { updateUrl = true } = {}) => ({ updateUrl })],
    ...map(SearchTypes, () => ({
      // TODO: normalize parameters
      SET_SELECTED_ID: [
        payload => payload,
        (payload, { ...meta } = {}) => ({ ...meta })
      ]
    })),
    SHOW_FIRST_RESULT: show => ({ show }),
    hideFilters: payload => payload,
    SHOW_MOBILE_SEARCH_FORM: () => ({})
  }
})

export const SearchTypeActions = Object.keys(SearchTypes).map(searchType => actions[searchType])
